import { useMutation } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

// Register (upsert) this device's APNs token for the current crew member.
export function usePushRegisterToken() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.push.registerToken.mutationOptions())
}

// Remove a device token (e.g. on sign-out).
export function usePushRemoveToken() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.push.removeToken.mutationOptions())
}
